<template>
  <div class="container">
    <!-- <contract-locale class="no-print" /> -->
    <div id="contract">
      <contract-header />
      <company-output />
      <employee-output />
      <employment-details-output />
      <pension-output />
      <health-control-output />
      <job-categories-output />
      <working-hours />
      <salary-output />
      <working-condtions-output />
      <salary-period-output />
      <driving-license-output />
      <tachograph-license-output />
      <qualifications-output />
      <education-output />
      <sickness-output />
      <holiday-output />
      <other-absence-output />
      <working-time-directive />
      <social-security-institutions-output />
      <special-terms-output />
      <contract-signature />
    </div>
  </div>
</template>

<script>
import CompanyOutput from "@/shared/components/contract/CompanyOutput";
import ContractHeader from "./Header";
// import ContractLocale from "./ContractLocale";
import ContractSignature from "./Signature";
import DrivingLicenseOutput from "@/shared/components/contract/DrivingLicenseOutput";
import EducationOutput from "./EducationOutput";
import EmployeeOutput from "@/shared/components/contract/EmployeeOutput";
import EmploymentDetailsOutput from "./EmploymentDetailsOutput";
import QualificationsOutput from "@/shared/components/contract/QualificationsOutput";
import HealthControlOutput from "@/shared/components/contract/HealthControlOutput";
import HolidayOutput from "@/shared/components/contract/HolidayOutput";
import JobCategoriesOutput from "@/shared/components/contract/JobCategoriesOutput";
import OtherAbsenceOutput from './OtherAbsenceOutput';
import PensionOutput from "@/shared/components/contract/PensionOutput";
import SalaryOutput from "@/shared/components/contract/SalaryOutput";
import SalaryPeriodOutput from "@/shared/components/contract/SalaryPeriodOutput";
import SicknessOutput from "./SicknessOutput";
import SocialSecurityInstitutionsOutput from "@/shared/components/contract/SocialSecurityInstitutionsOutput";
import SpecialTermsOutput from "@/shared/components/contract/SpecialTermsOutput";
import TachographLicenseOutput from "@/shared/components/contract/TachographLicenseOutput";
import WorkingHours from "./WorkingHours";
import WorkingCondtionsOutput from "./WorkingConditionsOutput";
import WorkingTimeDirective from "./WorkingTimeDirective";

export default {
  components: {
    CompanyOutput,
    ContractHeader,
    // ContractLocale,
    ContractSignature,
    DrivingLicenseOutput,
    EducationOutput,
    EmployeeOutput,
    EmploymentDetailsOutput,
    QualificationsOutput,
    HealthControlOutput,
    HolidayOutput,
    JobCategoriesOutput,
    OtherAbsenceOutput,
    PensionOutput,
    SalaryOutput,
    SalaryPeriodOutput,
    SicknessOutput,
    SocialSecurityInstitutionsOutput,
    SpecialTermsOutput,
    TachographLicenseOutput,
    WorkingCondtionsOutput,
    WorkingHours,
    WorkingTimeDirective
  },
  data() {
    return {
      outputObserver: "",
    };
  },
  mounted: function () {
    this.createOutputObserver();
    this.observeOutputElements();
  },
  methods: {
    /**
     *  These methods highlights the output fields in the contract component, whenever the user is typing in the corresponding input field.
     *  We use a mutation observer to register all user-output elements in the contract component for observation with one piece of code, intead of having to write 100 watcher methods.
     *  Whenever a user types something, the change in data will trigger the observer's callback. In this callback a css styling is applied to the html element and removed again after a short timeout event.
     *  Because each keyup event will trigger the callback, many timeout events can potentially be active at once. To make sure that only the last timeout event will remove the highlighted styles, each element
     *  is mapped together with a counter, and only when the last timeout event is running, will the last highlighted styles be removed.
     */
    createOutputObserver() {
      const highlightClass = "highlight-text";
      const timeoutDuration = 500;
      let counterCollection = new Map();

      this.outputObserver = new MutationObserver(function (mutations) {
        for (let i = 0; i < mutations.length; i++) {
          mutationCallback(mutations[i].target.parentNode);
        }
      });

      let mutationCallback = function (element) {
        let counter = counterCollection.get(element);

        if (counter == undefined) {
          counter = 0;
        }

        counterCollection.set(element, ++counter);

        setTimeout(() => timeoutCallback(element), timeoutDuration);

        element.classList.add(highlightClass);
      };

      let timeoutCallback = function (element) {
        let counter = counterCollection.get(element);
        counterCollection.set(element, --counter);

        if (counter > 0) {
          return;
        }
        counterCollection.delete(element);
        element.classList.remove(highlightClass);
      };
    },

    /*
                  Register all user-output elements for observation
                */
    observeOutputElements() {
      let observedElements = this.$el.querySelectorAll(".user-output");
      for (let i = 0; i < observedElements.length; i++) {
        this.outputObserver.observe(observedElements[i], {
          characterData: true,
          subtree: true,
        });
      }
    },
  },
};
</script>

<style>
#contract {
  box-sizing: border-box;
  border: 1px solid black;
  padding: 1rem 1rem;
}

#contract h1 {
  text-align: center;
  font-size: 1.2rem;
}

.margin-right-number {
  margin-right: 0.6rem;
}

.margin-left {
  margin-left: 1.5rem;
}

.user-output {
  transition: background 0.2s ease-in-out;
}

.highlight-text,
.highlight-enter {
  background: #1cd6ac;
}

.highlight-enter-active {
  transition: background 1s ease-in-out;
}

.highlight-enter-to {
  background: white;
}

.square {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #000;
  margin-right: 0.5rem;
  padding-top: 1px;
  padding-bottom: 1px;
}
.square .fa-check {
  position: relative;
  top: -3px;
  font-size: 18px;
}

.square .fa-times {
  position: relative;
  top: -4px;
  left: 2px;
  font-size: 17px;
}

hr {
  border-top: 1px solid #000 !important;
  margin-top: 0;
}

div.container.no-padding-margin {
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
}

.inline-wrap {
  display: flex;
  flex-wrap: wrap;
}

@media only screen and (min-width: 426px) {
  #contract h1 {
    font-size: 1.2rem;
  }
}

@media only screen and (min-width: 769px) {
  #contract {
    padding: 1rem 2rem;
  }
  #contract h1 {
    font-size: 1.5rem;
  }
}

@media only screen and (min-width: 1025px) {
  #contract {
    padding: 1rem 3rem;
  }
  #contract h1 {
    font-size: 2rem;
  }
}

@media print {
  #contract {
    border: 0;
    padding: 0;
    margin: 0;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  #contract h1 {
    font-size: 2rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}
</style>
